module.exports = __webpack_public_path__ + "img/Img_2.ad720d36.jpg";